import { daysInMonth, type FiscalDefinedBy, type FiscalPeriodConfig } from 'utils/fiscalPeriods';

/**
 * Merge a partial update into a fiscal period config, locking defined_by for
 * iso_week and clamping anchor_day into [1, daysInMonth(month)].
 * Non-integer / NaN day values keep the previous valid day (or 1).
 */
export function patchFiscalPeriodConfig(config: FiscalPeriodConfig, partial: Partial<FiscalPeriodConfig>): FiscalPeriodConfig {
  const anchor_rule = partial.anchor_rule ?? config.anchor_rule;
  // ISO week already names period 1 (week containing the 4th). The year-end /
  // period-start choice only applies to the other rules; leaving ISO lands on
  // year-end, which is the usual way to write nearest / on-or-before calendars.
  const defined_by: FiscalDefinedBy =
    anchor_rule === 'iso_week' ? 'period_start' : (partial.defined_by ?? (config.anchor_rule === 'iso_week' ? 'year_end' : config.defined_by));
  const next = { ...config, ...partial, anchor_rule, defined_by };
  const maxDay = daysInMonth(next.anchor_month);
  const previousDay = Number.isInteger(config.anchor_day) && config.anchor_day >= 1 ? config.anchor_day : 1;
  const rawDay = next.anchor_day;
  const day = Number.isInteger(rawDay) ? rawDay : previousDay;
  next.anchor_day = Math.min(Math.max(day, 1), maxDay);
  return next;
}
